import React from "react"
import "./DirectCheckoutSteps.css"

function DirectCheckoutSteps({ className, setActiveStep, steps, activeStep }) {
  function handleButtonClick(e) {
    const val = e.target.value
    steps.includes(val) && setActiveStep && setActiveStep(val)
  }
  function getActiveStepTitle(step) {
    switch (step) {
      case "info":
        return "Customer Information"
      case "shipping":
        return "Shipping Method"
      case "payment":
        return "Payment Method"

      default:
        break
    }
  }
  return (
    <>
      <div className={`DirectCheckoutSteps ${className}`}>
        <button
          className={`${activeStep === "cart" ? "active" : ""} ${steps.includes(
            "cart"
          ) && "been-here"}`}
          type="button"
          value="cart"
          onClick={handleButtonClick}
        >
          Shopping Cart
        </button>
        <button
          className={`${activeStep === "info" ? "active" : ""} ${steps.includes(
            "info"
          ) && "been-here"}`}
          type="button"
          value="info"
          onClick={handleButtonClick}
        >
          Customer Information
        </button>
        <button
          className={`${
            activeStep === "shipping" ? "active" : ""
          } ${steps.includes("shipping") && "been-here"}`}
          type="button"
          value="shipping"
          onClick={handleButtonClick}
        >
          Shipping Method
        </button>
        <button
          className={`${
            activeStep === "payment" ? "active" : ""
          } ${steps.includes("payment") && "been-here"}`}
          type="button"
          value="payment"
          onClick={handleButtonClick}
        >
          Payment Method
        </button>
      </div>
      {activeStep !== "cart" && (
        <h1 className="for-mobile">{getActiveStepTitle(activeStep)}</h1>
      )}
    </>
  )
}

export default DirectCheckoutSteps
